export const InsuranceAge: { value: number; label: string }[] = [
  { value: 16, label: '16-20' },
  { value: 21, label: '21-24' },
  { value: 25, label: '25-34' },
  { value: 35, label: '35-44' },
  { value: 45, label: '45-54' },
  { value: 55, label: '55-65' },
  { value: 66, label: '65+' },
] as const;
